// extracted by mini-css-extract-plugin
module.exports = {"main":"AccountMainPage_main__PHFDz","tabs-container":"AccountMainPage_tabs-container__rr4o5","cards":"AccountMainPage_cards__QPq8Z","loading":"AccountMainPage_loading__6HLp_"};